const APPLY_LOCALE_TEMPLATES = {
    "en": {
        "apply.title": "Glad you're here!",
        "apply.subtitle": "Enter your details to apply.",
        "apply.email.label": "Email",
        "apply.email.placeholder": "you@email.com",
        "apply.first.name.label": "First name",
        "apply.first.name.placeholder": "Your first name",
        "apply.last.name.label": "Last name",
        "apply.last.name.placeholder": "Your last name",
        "apply.phone.label": "Phone number",
        "apply.phone.error": "Please enter a complete phone number.",
        "apply.phone.whatsapp.disclosure": "We'll send you updates and reminders about your application at {company} via WhatsApp. You can opt out at any time by replying STOP.",
        "apply.phone.whatsapp.disclosureNoCompany": "We'll send you updates and reminders about your application via WhatsApp. You can opt out at any time by replying STOP.",
        "apply.cv.label": "CV",
        "apply.cv.optional": "optional",
        "apply.cv.choose": "Choose your CV",
        "apply.cv.drop": "Drag your CV here or {browse}",
        "apply.cv.browse": "browse",
        "apply.cv.hint": "PDF or Word (.pdf, .docx), max. 10 MB",
        "apply.cv.remove": "Remove CV",
        "apply.cv.type.error": "Upload a PDF or Word document (.pdf or .docx).",
        "apply.cv.size.error": "Your CV can be no larger than 10 MB.",
        "apply.error.generic": "Something went wrong. Please try again in a moment.",
        "apply.cta.loading": "One moment…",
        "apply.cta.next": "Next",
    },
    "nl": {
        "apply.title": "Goed dat je er bent!",
        "apply.subtitle": "Vul je gegevens in om te solliciteren.",
        "apply.email.label": "E-mail",
        "apply.email.placeholder": "jij@email.nl",
        "apply.first.name.label": "Voornaam",
        "apply.first.name.placeholder": "Je voornaam",
        "apply.last.name.label": "Achternaam",
        "apply.last.name.placeholder": "Je achternaam",
        "apply.phone.label": "Telefoonnummer",
        "apply.phone.error": "Vul een volledig telefoonnummer in.",
        "apply.phone.whatsapp.disclosure": "Via WhatsApp sturen we je updates en reminders over je sollicitatie bij {company}. Afmelden kan altijd door STOP te sturen.",
        "apply.phone.whatsapp.disclosureNoCompany": "Via WhatsApp sturen we je updates en reminders over je sollicitatie. Afmelden kan altijd door STOP te sturen.",
        "apply.cv.label": "CV",
        "apply.cv.optional": "optioneel",
        "apply.cv.choose": "Kies je cv",
        "apply.cv.drop": "Sleep je cv hierheen of {browse}",
        "apply.cv.browse": "blader",
        "apply.cv.hint": "PDF of Word (.pdf, .docx), max. 10 MB",
        "apply.cv.remove": "Verwijder cv",
        "apply.cv.type.error": "Upload een PDF- of Word-bestand (.pdf of .docx).",
        "apply.cv.size.error": "Je cv mag maximaal 10 MB zijn.",
        "apply.error.generic": "Er ging iets mis. Probeer het zo nog eens.",
        "apply.cta.loading": "Bezig…",
        "apply.cta.next": "Volgende",
    }
}

export default APPLY_LOCALE_TEMPLATES;
